// @flow
import * as React from 'react';
import { FieldWrapper } from 'speed-js-react-web';
import { Box, Text, TextInput } from 'grommet';
import styled from 'styled-components';
import StyledCloseButton
    from 'speed-js-react-web/src/components/grommet2/forms/fields/StyledCloseButton';


const StyledBox = styled(Box)`
    position: absolute;
    right: 10px
`;

const StyledText = styled(Text)`
    line-height: 9px;
`;

type Props = {
    label: React.Node,
    placeholder: React.Node,
    onChange: Function,
    value: ?number,
    unit?: string,
    error?: React.Node,
    required?: boolean,
};

const LengthInput = (props: Props) => {
    const {
        label, placeholder, onChange, value, unit, error, required, ...rest
    } = props;

    return (
        <FieldWrapper
            key="range-field"
            label={label}
            required={required}
        >
            <TextInput
                name="length-input"
                type="number"
                onChange={onChange}
                placeholder=""
                min={1}
                value={value || ''}
                style={{ paddingRight: 46 }}
                {...rest}
            />
            {unit && (
                <StyledBox
                    style={{ bottom: '12px', right: 6 }}
                >
                    <StyledText>{unit}</StyledText>
                </StyledBox>
            )}
            {value && (
                <StyledBox style={{ bottom: 0, right: 17 }}>
                    <StyledCloseButton onClick={() => { onChange({ target: { value: null } }); }} plain />
                </StyledBox>
            )}
            {error && (
                <Text
                    color="status-error"
                    alignSelf="center"
                    margin={{ bottom: '10px' }}
                >
                    {error}
                </Text>
            )}
        </FieldWrapper>
    );
};

LengthInput.defaultProps = {
    unit: undefined,
    error: undefined,
    required: false,
};

export default LengthInput;
